export function headerMenuAction() {
    let windowW;
    let header = $(".header");
    let counter = 0;
    let opener = $(".menu-open");
    let win = $(window);
    let sliderContainer = header.find(".header-slider");
    let searchInputWrap = header.find(".inputs-holder");
    let searchInput = searchInputWrap.find(".input-holder > input");

    win.on("resize", function () {
        windowW = win.width();

        if (windowW >= 1200) {

            if (counter < 1) {
                header.find("nav").css("display", "flex");
                $("body").removeClass("scroll-lock");
                opener.removeClass("open");

                if (header.hasClass("show-menu")) {
                    header.removeClass("show-menu");
                }

                counter++;
            }

        } else {
            if (counter > 0) {
                header.find("nav").css("display", "none");
                counter = 0;
            } else {
                header.find("nav").css("display", "block");
            }
        }
    });

    win.on("scroll", function () {
        header[(win.scrollTop() >= 1 ? "add" : "remove") + "Class"]("header-fixed");
    });

    if (sliderContainer.length && win.width() >= 1200) {

        let curSlider = sliderContainer.find(".slider");

        if (curSlider.find(".slider-item").length > 2) {
            let arrowsContainer = sliderContainer.find(".slider-arrows");

            curSlider.slick({
                dots: false,
                infinite: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                appendArrows: arrowsContainer,
                nextArrow: "<button><svg width='16' height='6' viewBox='0 0 16 6' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.791992 2.5C0.51585 2.5 0.291992 2.72386 0.291992 3C0.291992 3.27614 0.51585 3.5 0.791992 3.5V2.5ZM15.792 3L10.792 0.113249V5.88675L15.792 3ZM0.791992 3.5H11.292V2.5H0.791992V3.5Z' fill='#ED174F'/></svg></button>",
                prevArrow: "<button><svg width='17' height='6' viewBox='0 0 17 6' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.791992 3L5.79199 5.88675V0.113249L0.791992 3ZM15.792 3.5C16.0681 3.5 16.292 3.27614 16.292 3C16.292 2.72386 16.0681 2.5 15.792 2.5V3.5ZM5.29199 3.5H15.792V2.5H5.29199V3.5Z' fill='#ED174F'/></svg></button>",
            });
        }
    }

    searchInput.on("focus", function () {
        searchInputWrap.addClass("focus");
    });

    searchInput.on("blur", function () {
        searchInputWrap.removeClass("focus");
    });

    opener.on("click", function () {
        $(this).toggleClass("open");
        $(this).closest("header").toggleClass("show-menu");
        $("body").toggleClass("scroll-lock");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/header.js